import { createCrudApi } from '@core/api/createCrudApi';
import type { Tenant } from '@core/api/tenant';
import type { UserRole } from '@core/enum/userRole';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface User extends BaseEntity {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone?: string | null;
  birthday?: string | null;
  profilePicture?: string | null;
  address?: string | null;
  role: UserRole;
  tenant?: Tenant | null;
  plainPassword?: string;
}

export interface CreateUserData {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone?: string;
  role: UserRole;
  tenant?: number | null;
}

export type UpdateUserData = Partial<CreateUserData>;

const userApi = createCrudApi<User, CreateUserData, UpdateUserData>('user');

export const getAllUsers = userApi.getAll;
export const getUserById = userApi.getById;
export const createUser = userApi.create;
export const updateUser = userApi.update;
export const deleteUser = userApi.delete;

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export async function changeUserPassword(
  id: number,
  data: ChangePasswordData
): Promise<void> {
  await axiosInstance.post(`/user/${id}/change-password`, data);
}

export async function resetUserPassword(id: number): Promise<User> {
  const { data } = await axiosInstance.post<User>(`/user/${id}/reset-password`);
  return data;
}
